<template>
	<div>
		<el-form :model="goods" :rules="rules" style="text-align:left" label-position="right" label-width="180px" ref="goods"  size="small" >
				<el-row :gutter="2">
					<el-col :span="12">
						<el-form-item label="商品名称" prop="name">
							<el-input v-model="goods.name"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="商品价格" prop="price">
							<el-input  min=0 type="number" v-model="goods.price"></el-input>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row :gutter="2">
					<el-col :span="12">
						<el-form-item label="商品描述" prop="detail">
							<el-input v-model="goods.detail"></el-input>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row :gutter="2">
					<el-col :span="12">
						<el-form-item label="图片" prop="imgSource">
							<el-upload
							  class="upload-demo"
							  list-type="picture-card"
							  :show-file-list="false"
							  action="/api/img/upload"
							  :limit="1"
							  :before-upload="beforeAvatarUpload"
							  :on-remove="handleRemove"
							  :on-success="handleAvatarSuccess"
							  >
							  <img v-if="goods.imgSource" :src="goods.imgSource" class="avatar" height="186px" width="186px" />
  								<i v-else class="el-icon-plus avatar-uploader-icon"></i>
							  <div slot="tip" class="el-upload__tip">只能上传jpg/png文件，且不超过500kb</div>
							</el-upload>
						</el-form-item>
					</el-col>
				</el-row>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click.native="backToLisk">返回</el-button>
				<el-button type="primary" @click.native="addSubmit" :loading="addLoading">提交</el-button>
			</div>
	</div>
</template>
<style>
	  .el-upload {
	    width: 186px;
	    height: 186px;
	    line-height:186px;
	  }
	  
  </style>
<script>
	import {getGoods,addGoods} from '@/api/api.js'
	import tools from "@/tools"
	import Editor from 'wangeditor'
	import 'wangeditor/release/wangEditor.min.css'
	export default {
		components:{
			Editor
		},
		data(){
			return {
				goods:{
					id:'',
					detail:'',
					name:'',
					price:'',
					imgSource:""
				},
				rules: {
		          detail: [
		            { required: true, message: '请输入商品描述', trigger: 'blur' }
		          ],
		          name: [
		            { required: true, message: '请输入商品名称', trigger: 'blur' }
		          ],
		          price: [
		            { required: true, message: '请输入商品价格', trigger: 'blur' }
		          ]
		        },
				addLoading:false
			}

		},
		created:function() {
			var id = this.$route.query.id;
			
			if(id){
				getGoods({id:id}).then(res=>{
					this.goods = res.data.data;
				})
			};
			
		},
		methods:{
			addSubmit(){
				
				this.$refs["goods"].validate((valid)=>{
					this.addLoading=true;
					if(valid){
						addGoods(this.goods).then(res=>{
							if(res.data.status=="success"){
								this.$message('添加成功');
								this.addLoading=false;
								this.$router.go(-1);
							}
						});	
					};
					this.addLoading=false;	
				});
			},
			beforeAvatarUpload(file) {
		        const isJPG = file.type === 'image/jpeg';
		        const isPNG = file.type === 'image/png';
		        const isLt2M = file.size / 1024 / 1024 < 2;
		        
		        if (!isJPG && !isPNG) {
		          this.$message.error('上传头像图片只能是 JPG/JPEG/PNG 格式!');
		        }
		        if (!isLt2M) {
		          this.$message.error('上传头像图片大小不能超过 2MB!');
		        }
		        return isJPG && isLt2M;
		    },
			handleAvatarSuccess(res, file,fileList) {
				
				
				this.goods.imgSource=res.data;
				
				return false
			
		    },

		    handleRemove(file, fileList){


		    },
		    backToLisk(){
		    	this.$router.go(-1);
		    }
		}
	}
</script>